type IdentityUser = {
  firstName?: string | null
  lastName?: string | null
  email?: string | null
} | null | undefined

type IdentityContact = {
  value?: string | null
  label?: string | null
} | null | undefined

type IdentitySource = {
  display_name?: string | null
  primary_email?: string | null
  first_name?: string | null
  last_name?: string | null
  user?: IdentityUser
  email_contacts?: IdentityContact[] | null
}

function joinName(parts: Array<string | null | undefined>): string | null {
  const joined = parts
    .map((part) => (typeof part === "string" ? part.trim() : ""))
    .filter(Boolean)
    .join(" ")
    .trim()

  return joined || null
}

export function getPreceptorDisplayName(preceptor: IdentitySource | null | undefined): string {
  if (!preceptor) {
    return "Unknown"
  }

  return (
    (typeof preceptor.display_name === "string" && preceptor.display_name.trim()) ||
    joinName([preceptor.first_name, preceptor.last_name]) ||
    joinName([preceptor.user?.firstName, preceptor.user?.lastName]) ||
    "Unknown"
  )
}

export function getPreceptorPrimaryEmail(preceptor: IdentitySource | null | undefined): string | null {
  if (!preceptor) {
    return null
  }

  const normalizedPrimaryEmail =
    typeof preceptor.primary_email === "string" ? preceptor.primary_email.trim() : ""
  if (normalizedPrimaryEmail) {
    return normalizedPrimaryEmail
  }

  const contacts = Array.isArray(preceptor.email_contacts) ? preceptor.email_contacts : []
  const primaryContact = contacts.find(
    (contact) =>
      typeof contact?.value === "string" &&
      contact.value.trim() &&
      typeof contact?.label === "string" &&
      contact.label.trim().toLowerCase() === "primary",
  )
  if (primaryContact?.value?.trim()) {
    return primaryContact.value.trim()
  }

  const firstContact = contacts.find(
    (contact) => typeof contact?.value === "string" && contact.value.trim(),
  )
  if (firstContact?.value?.trim()) {
    return firstContact.value.trim()
  }

  const userEmail = typeof preceptor.user?.email === "string" ? preceptor.user.email.trim() : ""
  return userEmail || null
}

export function getPreceptorInitials(preceptor: IdentitySource | null | undefined): string {
  const displayName = getPreceptorDisplayName(preceptor)
  const initials = displayName
    .split(/\s+/)
    .map((part) => part[0] ?? "")
    .join("")
    .slice(0, 2)
    .toUpperCase()

  return initials || "PR"
}
